module.exports = __webpack_public_path__ + "static/_/src/components/TrGame/v4/GameEngines/MbRoulette//click.mp3";